import { render, staticRenderFns } from "./FragmentSidebar.vue?vue&type=template&id=5f07fd5c"
import script from "./FragmentSidebar.vue?vue&type=script&lang=ts"
export * from "./FragmentSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports